export function splitStringIntoChunks(str: string, size?: number) {
  if (!size || str.length <= size) return [str];

  const chunks: string[] = [];
  let i = 0;

  while (i < str.length) {
    let sliced = str.substring(i, i += size);
    const wordWasSliced = sliced[sliced.length - 1] !== ' '
      && i < str.length
      && str[i] !== ' ';

    if (wordWasSliced) {
      sliced = `${sliced}-`;
    }
    chunks.push(sliced);
  }
  return chunks;
}